import { useSyncExternalStore } from "react"

export type ColorScheme = "light" | "dark"

function subscribe(callback: () => void) {
  const observer = new MutationObserver(callback)
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  })
  return () => observer.disconnect()
}

function getSnapshot(): ColorScheme {
  return document.documentElement.classList.contains("dark") ? "dark" : "light"
}

// useColorScheme reads the active color scheme from the `dark` class on the
// document root — the same signal Tailwind's `dark:` variant keys off of — so
// it stays in sync without coupling shared-web to any app's store.
export function useColorScheme(): ColorScheme {
  return useSyncExternalStore(subscribe, getSnapshot, () => "light")
}
